<div class="text-center" [innerHtml]="svgWithInnerText | sanitizeHtml"></div>